export const PAYMENT_CONSISTENCY_RUNTIME_KEYS = new Set([
  'PAYMENT_STATE_CONSISTENCY_PROFILE',
  'WEBHOOK_SOURCE_EVENT_IDEMPOTENCY_ENABLED',
  'ONCHAIN_PAYMENT_SIDEFX_JOB_EXECUTION_ENABLED',
  'ORDER_STATE_TRANSITION_COORDINATOR_ENABLED',
  'ORDER_SIDE_EFFECT_JOBS_ENABLED',
  'PAYMENT_LOG_RECONCILIATION_ENABLED',
])

export const resolveRuntimeConfigModuleId = (key: string): string => {
  const normalized = key.toUpperCase()
  const compact = normalized.replace(/_/g, '')
  const hasPrefix = (prefix: string) =>
    normalized.startsWith(prefix) || compact.startsWith(prefix.replace(/_/g, ''))

  if (PAYMENT_CONSISTENCY_RUNTIME_KEYS.has(normalized)) return 'paymentConsistency'
  if (normalized.includes('WEBHOOK') || compact.includes('WEBHOOK')) return 'webhook'
  if (hasPrefix('ADMIN_')) return 'admin'
  if (hasPrefix('AUTH_')) return 'auth'
  if (hasPrefix('CACHE_')) return 'cache'
  if (hasPrefix('COOLDOWN_')) return 'feature'
  if (hasPrefix('ENABLE_')) return 'feature'
  if (hasPrefix('RATE_LIMIT_')) return 'rateLimit'
  if (hasPrefix('MFA_')) return 'security'
  if (hasPrefix('MAIL_')) return 'mail'
  if (hasPrefix('SUPPORT_')) return 'support'
  if (hasPrefix('ALCHEMY_')) return 'alchemy'
  if (hasPrefix('MAINNET_ONCHAIN_')) return 'onchain'
  if (hasPrefix('ONCHAIN_')) return 'onchain'
  if (hasPrefix('GAS_')) return 'gas'
  if (hasPrefix('PAYMENT_')) return 'payment'
  if (hasPrefix('ORDER_')) return 'order'
  if (hasPrefix('PLATFORM_')) return 'platform'
  if (hasPrefix('TESTNET_')) return 'testnet'
  if (hasPrefix('TURNSTILE_')) return 'turnstile'
  return 'other'
}
